





























































































































import * as path from 'path';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  FileSystemItem,
  FileSystemService,
} from '../../services/FileSystem.service';

@Component({ name: 'SidebarItem' })
export default class SidebarItem extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  readonly item!: FileSystemItem;

  @Prop({
    type: String,
    required: false,
    default: undefined,
  })
  readonly selectedPath!: string;

  @Prop({
    type: String,
    required: false,
    default: undefined,
  })
  readonly pathBeingEdited!: string;

  @Prop({
    type: Array,
    required: true,
  })
  readonly collapsedPaths!: string[];

  @Prop({
    type: Number,
    required: false,
    default: 0,
  })
  readonly indent!: number;

  mounted() {
    this.proposedName = this.item.name;

    if (this.isEditing) {
      this.focusInputOnNextTick();
    }
  }

  proposedName: string = '';

  private cancelEdit = false;

  get indentStyle() {
    return {
      'padding-left': this.indent * 20 + 10 + 'px',
    };
  }

  get isSelected() {
    return this.selectedPath === this.item.path;
  }

  get isEditing() {
    return this.pathBeingEdited === this.item.path;
  }

  get proposedNameIsDuplicate() {
    return this.item.siblingNames.includes(this.proposedName);
  }

  get isFolderOpen() {
    return this.item.isFolder && !this.collapsedPaths.includes(this.item.path);
  }

  clicked() {
    this.$emit('pathSelected', this.item.path);
    if (this.item.isFolder) {
      this.$emit('folderToggled', this.item.path);
    }
  }

  deleteClicked() {
    this.$emit('pathDeleted', this.item.path);
  }

  pathSelected(path: string) {
    this.$emit('pathSelected', path);
  }

  pathEditing(path: string) {
    this.$emit('pathEditing', path);
  }

  pathRenamed(...args) {
    this.$emit('pathRenamed', ...args);
  }

  pathDeleted(path: string) {
    this.$emit('pathDeleted', path);
  }

  folderToggled(path: string) {
    this.$emit('folderToggled', path);
  }

  onNameEnterDown() {
    this.proposedName = this.item.name;
    this.$emit('pathEditing', this.item.path);
    this.focusInputOnNextTick();
  }

  onInputEnterDown() {
    this.$emit('pathEditing', null);
  }

  onInputEscDown() {
    this.cancelEdit = true;
    this.$emit('pathEditing', null);
  }

  onEditInputBlur() {
    if (this.cancelEdit || this.proposedNameIsDuplicate) {
      this.cancelEdit = true;
      this.proposedName = this.item.name;
    } else {
      this.renameItem();
    }
    this.$emit('pathEditing', null);
  }

  private async renameItem() {
    const oldPath = this.item.path;
    const newPath = path.join(oldPath, '../', this.proposedName);
    this.$emit('pathRenamed', oldPath, newPath);
  }

  private focusInputOnNextTick() {
    Vue.nextTick().then(() => {
      const editInput = <HTMLInputElement>this.$refs.editInput;
      editInput.select();
      editInput.focus();
    });
  }
}
